<template>
	<modal ref="modal" size="modal-lg">
		<template #title>{{action.toUpperCase()}} TRC COUPLE CONTENT</template>
		<template #body>
			<div class="form-floating mb-4">
				<input type="text" v-model="form.title" id="title" name="title" class="form-control" placeholder="Title" />
				<label class="form-label" for="title">Title</label>
			</div>
			<div class="form-floating mb-4">
				<input type="text" v-model="form.vimeo_id" id="vimeo_id" name="vimeo_id" class="form-control" placeholder="Vimeo ID" />
				<label class="form-label" for="vimeo_id">Vimeo ID</label>
			</div>
			<div class="form-floating mb-4">
				<label class="form-label" for="description">Description</label>
				<textarea id="ckeditor_trc_couple_content"></textarea>
			</div>
			<div class="form-floating mb-4">
				<flat-pickr
					v-model="form.date_start"
					id="date_start"
					name="date_start"
					class="form-control form-control-sm"
					:config="{
						enableTime: true,
						altInput: true,
						altFormat: 'M j, Y h:i K',
						dateFormat: 'Y-m-d H:i:s',
					}"
					placeholder="Date Start"
				/>
				<label class="form-label" for="date_start">Date Start</label>
			</div>
			<div class="form-group mb-4">
				<label class="form-label" for="status">Status</label>
				<div class="mt-2">
					<div class="form-check form-check-inline">
						<input
							v-model="form.status"
							id="status_on"
							name="status"
							class="form-check-input"
							type="radio"
							value="ON"
						/>
						<label class="form-check-label bg-alt-primary" for="ON">ON</label>
					</div>
					<div class="form-check form-check-inline">
						<input
							v-model="form.status"
							id="status_off"
							name="status"
							class="form-check-input"
							type="radio"
							value="OFF"
						/>
						<label class="form-check-label bg-alt-primary" for="OFF">OFF</label>
					</div>
				</div>
			</div>
		</template>
		<template #footer>
			<button 
				@click="actionContent"
				type="submit"
				class="btn btn-alt-primary"
				:disabled="form.processing || !form.isDirty"
			>
				<span v-if="!form.processing"><i class="fa fa-save me-2"></i><span v-if="action=='add'">Add</span><span v-else>Update</span> Content</span>
					<span v-else>
						<div class="spinner-border spinner-border-sm text-dark" role="status" >
							<span class="sr-only mr-1">Please wait...</span>
						</div>
						<span class="mx-2">Please wait...</span>
					</span>
			</button>
			<button
				@click="toggleModal"
				type="button"
				class="btn btn-alt-secondary"
				:disabled="form.processing"
			>
				Close
			</button>
		</template>
	</modal>
</template>

<script>
import { watch, ref } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'
import CKEditorInit from './../../Shared/ckeditor-init';

export default {
	props: {
		
	},
	mounted(){
		CKEditorInit('ckeditor_trc_couple_content');
	},
	setup(props) {
		const modal = ref(null)

		const toggleModal = () => {

			if(action.value=='add')
			{
				window['ckeditor_trc_couple_content'].setData('<p></p>');
			}else
			{
				if(form.description!==null)
				{
					window['ckeditor_trc_couple_content'].setData(form.description);	
				}
				
			}

			modal.value.toggleModal();
		}
		
		const action = ref('add');

		const form = useForm({
			couple_content_uuid: 0,
			title 			: null,
			vimeo_id 		: null,
			description 	: null,
			date_start 		: null,
			status 			: 'ON'
		})

		const actionContent = ()=>{

			form.description = window['ckeditor_trc_couple_content'].getData();

			if(action.value=='add')
			{
				addContent();
			}else
			{
				updateContent();	
			}

		}

		const addContent = () => {
			form.post(route('admin.trc-couples.post.content'), {
				preserveState: true,
				preserveScroll: true,
				only:['contents,api_response'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}

		const updateContent = () => {
			form.put('content/'+form.couple_content_uuid, {
				preserveState: true,
				preserveScroll: true,
				only:['contents,api_response'],
				onSuccess: () => {
					form.reset();
					toggleModal();
				},
			})
		}

		const setTrcCoupleContent = (_action,data)=>{
								
								form.reset();

								action.value = _action;

								if(_action=='update')
								{
									form.couple_content_uuid 	= data.couple_content_uuid;
									form.title 				= data.title;
									form.vimeo_id 			= data.vimeo_id;
									form.description 		= data.description;
									form.date_start 		= data.date_start;
									form.status 			= data.status;
								}
								
							}


		return {
			form,
			modal,
			toggleModal,
			action,
			setTrcCoupleContent,
			actionContent,
			addContent,
			updateContent,
		}
	},
}
</script>

<style>
	.ck-content,.ck-source-editing-area{
		height: 300px;
	}
	
	.ck-content, .ck.ck-balloon-panel{
		z-index: 1055;
	}
</style>